const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.619,3.5l0,6.5c0,0.192 0.056,0.38 0.16,0.542l5.565,8.633c0.009,0.015 0.019,0.029 0.029,0.043c0.129,0.179 0.204,0.441 0.063,0.617c-0.12,0.15 -0.354,0.176 -0.682,0.158c-0.012,-0.001 -3.3,0.002 -6.737,0.007c-0.552,0.001 -0.999,0.449 -0.999,1.001c0.001,0.552 0.45,1 1.002,0.999c3.379,-0.005 6.612,-0.011 6.624,-0.01c1.18,0.065 1.921,-0.364 2.354,-0.905c0.684,-0.855 0.631,-2.141 0.01,-3.019c0.005,0.007 -5.389,-8.36 -5.389,-8.36c0,-0 0,-6.206 0,-6.206c0,-0.552 -0.448,-1 -1,-1c-0.551,0 -1,0.448 -1,1Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.639,14.136c-0,0 2.22,-0.91 4.128,0.963c2.708,2.66 6.075,0.931 6.075,0.931c0.369,-0.189 0.514,-0.641 0.325,-1.009c-0.189,-0.369 -0.641,-0.514 -1.009,-0.325c-0,-0 -2.405,1.233 -4.34,-0.667c-2.655,-2.608 -5.761,-1.275 -5.761,-1.275c-0.382,0.16 -0.561,0.601 -0.4,0.982c0.16,0.381 0.6,0.561 0.982,0.4Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5.49l-2.314,0c-0.414,0 -0.75,0.336 -0.75,0.75c-0,0.414 0.336,0.75 0.75,0.75l2.314,0c0.414,0 0.75,-0.336 0.75,-0.75c-0,-0.414 -0.336,-0.75 -0.75,-0.75Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,8.5l-1.868,-0c-0.414,0 -0.75,0.336 -0.75,0.75c0,0.414 0.336,0.75 0.75,0.75l1.868,0c0.414,0 0.75,-0.336 0.75,-0.75c0,-0.414 -0.336,-0.75 -0.75,-0.75Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,13.5l-3.726,5.5l0.226,1.653l3,0.347l12,0l1.5,-1.5l-2.25,-4l-2.25,0.261l-3.176,-0.761l-2.622,-1.734l-2.702,0.234Zm8,4c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Zm-6.112,0.887c-0.276,0 -0.499,-0.223 -0.499,-0.499c-0,-0.276 0.223,-0.499 0.499,-0.499c0.276,-0 0.499,0.223 0.499,0.499c0,0.276 -0.223,0.499 -0.499,0.499Zm-0.724,-3.06c0.461,0 0.836,0.375 0.836,0.837c-0,0.461 -0.375,0.836 -0.836,0.836c-0.462,0 -0.837,-0.375 -0.837,-0.836c0,-0.462 0.375,-0.837 0.837,-0.837Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.192,3l9.653,0",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.192,4l9.653,0c0.551,-0 1,-0.448 1,-1c-0,-0.552 -0.449,-1 -1,-1l-9.653,0c-0.552,-0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.381,3.5l-0,6.206c-0,-0 -5.394,8.367 -5.394,8.367c-0.616,0.877 -0.667,2.159 0.015,3.012c0.433,0.541 1.174,0.97 2.354,0.905c0.012,-0.001 3.245,0.005 6.624,0.01c0.552,0.001 1.001,-0.447 1.002,-0.999c0,-0.552 -0.447,-1 -0.999,-1.001c-3.437,-0.005 -6.725,-0.008 -6.737,-0.007c-0.328,0.018 -0.562,-0.008 -0.682,-0.158c-0.141,-0.176 -0.066,-0.438 0.063,-0.617c0.01,-0.014 0.02,-0.028 0.029,-0.043l5.565,-8.633c0.104,-0.162 0.16,-0.35 0.16,-0.542l-0,-6.5c-0,-0.552 -0.449,-1 -1,-1c-0.552,-0 -1,0.448 -1,1Z",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaker);
export default __webpack_public_path__ + "static/media/beaker.c16139bf39978eeaa6d6b1245352a10c.svg";
export { ForwardRef as ReactComponent };